import { authLogout } from "../../../store/actions/authActions";
import { clearMessage, setMessage } from "../../../store/actions/dialogActions";
import { clearGroups } from "../../../store/actions/groupsActions";
import { setNotifications } from "../../../store/actions/notificationActions";
import API from "../../../store/api";
import { getAllUsers } from "../user";
import { getAllGroups } from "./getAllGroups";

export const updateGroup = (id, groupData, bearerAuth, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.put(`/api/portal/groups/${id}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .send(groupData)
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(getAllGroups(bearerAuth))
          dispatch(getAllUsers(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully updated.'
          }))
          formFunction()
        } else if (response.status === 401) {
          dispatch(clearGroups);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Update Group Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}
/* Sample groupData
 * {
 *   "name": "LE",
 *   "enabled": "false",
 *   "siteId": "07ff846d-40ed-4075-be1d-f0e7ecf5ee1p",
 * }
*/